<template>
	<div class="sidebar">
		<div class="row justify-content-space-between">
			<div class="col-sm-8">
				<h5 class="bg-info px-4 py-2">{{ sideBarState.name }}</h5>
			</div>

			<div class="col-sm-4 d-flex justify-content-end">
				<button
					type="button"
					@click="logout"
					class="btn btn-danger btn-sm mb-1"
				>
					Log Out
				</button>
			</div>
		</div>
		<div class="row">
			<button
				type="button"
				@click="this.$router.push('/dash')"
				class="btn btn-primary btn-sm mb-1"
			>
				Dashboard
			</button>
		</div>
		<div class="row" v-if="sideBarState.activeRole === roles.env_admin">
			<button
				type="button"
				@click="this.$router.push('/user')"
				class="btn btn-primary btn-sm mb-1"
			>
				Users
			</button>
		</div>
	</div>
</template>

<script>
	import { inject, reactive } from "vue";
	import { useRouter } from "vue-router";
	export default {
		name: "TheSidebar",

		setup() {
			const store = inject("store");
			const router = useRouter();
			const roles = reactive({
				env_admin: process.env.VUE_APP_USER_ADMIN,
			});

			const sideBarState = reactive({
				name: null,
				activeRole: null,
			});

			sideBarState.name = store.state.user.name;
			sideBarState.activeRole = store.state.user.activeRole;

			const logout = () => {
				store.methods.removeState();
				router.push({ name: "Login", path: "/login" });
			};

			return {
				sideBarState,
				roles,
				logout,
			};
		},
	};
</script>
<style scoped>
	.sidebar {
		height: 100vh;
	}
</style>
